import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetScheduleMachine = createModule({
  base: 'GET_SCHEDULE_MACHINE',
  apiDetails: SERVICE_ENDPOINT.GET_MACHINE_SCHEDULE,
  errors: { defaultError: false, customError: '' },
});

export { GetScheduleMachine };